<template>
  <div class="article-2">
    <div class="article__info">
      <h1 class="article__title"><span>洪秀柱要創奇蹟</span><span>要先拿下這些搖擺里</span></h1>
      <div class="article__reporter">聯合報 記者：張文馨／報導</div>
    </div>
    <figure class="article__figure article__cover">
      <div class="article__figure-photo" :style="`background-image: url(${require('@/assets/articles/article-2-cover.jpg')})`"></div>
      <figcaption class="article__figure-caption">只要拿下一些中間色彩的區里，洪秀柱就能提高當選機會；圖為投開票所的投票情形。記者吳淑玲／攝影</figcaption>
    </figure>
    <p class="article__paragraph">洪秀柱投入台南市第六選區的立委選戰，短短不到200天的時間，想要打翻綠汁，用藍墨寫下奇蹟，可從仁德區仁和里這個藍營精神堡壘出發，然後站穩藍綠搖擺的東區12里，再一步步逼進深綠選區。</p>
    <p class="article__paragraph">這個選區雖然十年內由藍轉綠，但國民黨最低仍拿下4萬5902票，可視為藍營低標，高思博去年獲得5萬3925票；2012年時，馬英九更曾開出8萬餘票的紀錄，同年國民黨立委得票數為8萬7420票，洪秀柱明顯有開拓空間。</p>
    <p class="article__paragraph">至於如何開拓，根據歷年投票資料結果顯示，民進黨2008年在仁德區仁和里只開出9票，2012年為15票，2016年是112票，2018年黃偉哲只拿到61票，反觀國民黨這幾次選舉，最少拿下169票，最多有667票，得票率都維持在七成五以上，堪稱最藍選區。</p>

    <h2 class="article__subtitle">藍綠這些基本地盤<br/>近四年不斷位移</h2>
    <p class="article__paragraph">若以統計來分層計算，將台南第六選區89個里從深藍到深綠分成六大組，仁德區仁和里是屬於第一組，藍營支持者占比最多；而包括仁德區太子里、歸仁區看西里、關廟區南雄里等13個里，綠營支持者占比最多，被歸類最綠的第六組，若再加上穩定領先的第五組、23個里，綠營票倉約有36個里。</p>

    <div class="article__chart">
      <div class="article__chart-caption">藍綠得票選區分層圖</div>
      <div class="article__chart-table article-2__chart-table-1">
        <SvgSymbol class="svg" use="#article-2-chart-1"/>
      </div>
      <div class="article__chart-guide clearfix">
        <p>資料來源：中選會/本文自行彙整</p>
        <p>（各組催票率平均數，單位：百分比）</p>
      </div>
    </div>

    <!-- <div><a title="各組詳細資訊（含里及選舉人數資訊）">各組詳細資訊（含里及選舉人數資訊）</a></div> -->

    <div class="article__chart">
      <div class="article__chart-caption">台南市第六選區藍綠得票分層 - 各層詳細資訊</div>
      <div class="article__chart-table article-2__chart-table-2">
        <SvgSymbol class="svg" use="#article-2-chart-2"/>
      </div>
      <div class="article__chart-guide clearfix">
        <p>資料來源：中選會/本文自行彙整</p>
      </div>
    </div>

    <p class="article__paragraph">以催票率來觀察，國民黨在2008年、2012年的選舉時，在分層的第一、二組領先，等於只拿下21個里，其餘四組，民進黨穩定領先。但到了2016年，民進黨由王定宇參選時，民進黨甚至在第二組的催票率贏過國民黨。</p>
    <p class="article__paragraph">不過，這個局勢在2018年起了重大變化，高思博不僅光復了第二組，甚至將藍營版圖拓展到第三組，也就是東區的富裕里、裕農里、仁和里、自強里、和平里、衛國里、崇善里、富強里、虎尾里、德高里、東聖里和復興里。</p>
    <p class="article__paragraph">總體來說，若能延續去年聲勢，國民黨將可站穩一、二、三組總計的33個里，並向第四組的20個里挺進。同時，以催票率來看，藍綠在第三、四組的催票率勢均力敵，未來將成為雙方陣營的激戰區。</p>

    <h2 class="article__subtitle">拿下東區不一定贏<br/>柱姐還得搶這些區里</h2>
    <p class="article__paragraph">再以選舉人數分析，第二組的6萬8829人、第五組的6萬1779人，人數最多，會是藍綠積極回防鞏固的票源地區。然而，較綠的第四組有5萬2791人，比第三組的4萬2547人，大約多1萬人，凸顯民進黨的票源優勢。</p>
    <p class="article__paragraph">光從選舉人數計算，單一選區立委選戰只要超越選舉人數一半，代表篤定當選，以這個選區的25萬選舉人數計算，過半的人口將落在第四組，就是綠營優勢區；換句話說，就算洪秀柱全數拿下第一到第三組，也很難撼動選舉結果，必須積極開拓更多中間選民。</p>

    <BubbleChart />

    <p class="article__paragraph">舉例來說，第二組、第三組幾乎都落在東區，2008年立委選舉時，高思博在東區領先賴清德6127票，但最後賴清德靠其他選區回補票數，高思博依然不敵。</p>
    <p class="article__paragraph">洪秀柱這次獲得提名，高知名度加上大環境加持，能否轉化為選票，可從各分組呈現的催票率平均數來觀察，以立委選舉和總統選舉相較，立委比較接近「地面選戰」，總統選舉則受到「空氣票」影響較大。</p>
    <p class="article__paragraph">在地耕耘往往能在選舉中發揮效果，洪秀柱若要靠知名度或是論述主張來打這一場選戰，得票數將面臨挑戰。</p>
  </div>
</template>

<script>
import BubbleChart from '@/components/BubbleChart'
export default {
  name: 'Article2',
  components: {
    BubbleChart
  }
}
</script>

<style lang="scss">
.article-2 {
  &__chart-table-1 {
    @include use-fixed-ratio(841, 337);
  }
  &__chart-table-2 {
    @include use-fixed-ratio(838, 509);
  }
}
</style>
